import { createNamespacedHelpers } from 'vuex'
import * as GUIDE from 'src/api/dev/guide'
import * as T from './types'

const module = {
    namespaced: true,
    state: {
        content: {}
    },
    mutations: {
        [T.REL_GUIDES](state, data) {
            state.content = data
        }
    },
    actions: {
        async queryGuide({ commit }, key) {
            commit(T.REL_GUIDES, await GUIDE.list(key))
        }
    },
    getters: {
        content: state => Object.keys(state.content).reduce((result, key) => {
            result[key] = state.content[key].slice(0, 5)
            return result
        }, {})
    }
}
const { mapState, mapActions, mapGetters, mapMutations } = createNamespacedHelpers('guide')

export { mapState, mapActions, mapGetters, mapMutations }

export default module
